<script>
  export let stats;
  const getStats = async () => await stats;
</script>


{#await getStats()}
	<!-- promise is pending -->
	<p>waiting for the promise to resolve...</p>
{:then statsObj}
	<!-- promise was fulfilled -->
  {#each Object.entries(statsObj) as [key, value]}
    <h3>{key}</h3>
    <p>{value.length}</p>
  {/each}
{:catch error}
	<!-- promise was rejected -->
	<p>Something went wrong: {error.message}</p>
{/await}
